import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { RISK_COLOR, RiskGroupKey } from '@nk/utils-lib';

export const NETWORK_RISK_SCORE_COLOR = {
  very_low: 'green',
  low: 'green',
  medium: 'yellow',
  high: 'orange',
  very_high: 'red',
  unset: 'gray',
} as const;

export const NETWORK_RISK_SCORE_TRANSLATIONS: Record<NetworkRiskGroupKey, string> = {
  very_low: extractTranslation('network_risk.result_category_key.very_low'),
  low: extractTranslation('network_risk.result_category_key.low'),
  medium: extractTranslation('network_risk.result_category_key.medium'),
  high: extractTranslation('network_risk.result_category_key.high'),
  very_high: extractTranslation('network_risk.result_category_key.very_high'),
  unset: extractTranslation('network_risk.result_category_key.unset'),
};

export type NetworkRiskGroupKey = keyof typeof NETWORK_RISK_SCORE_COLOR;

export function isNetworkRiskGroupKey(item: string): item is NetworkRiskGroupKey {
  return !!item && Object.keys(NETWORK_RISK_SCORE_COLOR).includes(item);
}

/**
 * Maps a raw network risk score to a risk group.
 */
export function getNetworkRiskGroup(networkRiskScore: number): RiskGroupKey {
  // A very simple, preliminary adjustment to the score.
  // Will probably need tuning/additions.
  const adjustedScore = networkRiskScore / 2;
  if (adjustedScore <= 0) {
    return 'low';
  }
  if (adjustedScore <= 10) {
    return 'medium';
  }
  if (adjustedScore <= 20) {
    return 'high';
  }
  return 'very_high';
}

/**
 * Maps a raw network risk score to a RISK_COLOR hex.
 */
export function getNetworkRiskColor(networkRiskScore: number): string {
  return RISK_COLOR[getNetworkRiskGroup(networkRiskScore)];
}
